/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_alert_set_password_info = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You currently log in with social accounts. Set a password to log in with username/password as well.`)
};

const zh_hans1_settings_alert_set_password_info = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您当前使用社交账号登录。设置密码后也可以使用用户名/密码登录。`)
};

const zh_hant1_settings_alert_set_password_info = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你目前只使用社群登入。在移除所有登入方式之前，請先設定密碼。`)
};

const fr_settings_alert_set_password_info = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous vous connectez actuellement avec des comptes sociaux. Définissez un mot de passe pour vous connecter aussi avec nom d’utilisateur/mot de passe.`)
};

const de_settings_alert_set_password_info = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du meldest dich derzeit mit Social-Accounts an. Lege ein Passwort fest, um dich auch mit Benutzername/Passwort anzumelden.`)
};

const ja_settings_alert_set_password_info = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在はソーシャルアカウントでログインしています。パスワードを設定すると、ユーザー名/パスワードでもログインできます。`)
};

const ko_settings_alert_set_password_info = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소셜 로그인만 사용 중입니다. 모든 로그인 방법을 제거하기 전에 비밀번호를 설정하세요.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_alert_set_password_info = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_alert_set_password_info(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_alert_set_password_info", locale)
	if (locale === "en") return en_settings_alert_set_password_info(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_alert_set_password_info(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_alert_set_password_info(inputs)
	if (locale === "fr") return fr_settings_alert_set_password_info(inputs)
	if (locale === "de") return de_settings_alert_set_password_info(inputs)
	if (locale === "ja") return ja_settings_alert_set_password_info(inputs)
	return ko_settings_alert_set_password_info(inputs)
};